import { render, staticRenderFns } from "./controlSalesGoodsItem.vue?vue&type=template&id=25c8a409&scoped=true"
import script from "./controlSalesGoodsItem.vue?vue&type=script&lang=js"
export * from "./controlSalesGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./controlSalesGoodsItem.vue?vue&type=style&index=0&id=25c8a409&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8a409",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c8a409')) {
      api.createRecord('25c8a409', component.options)
    } else {
      api.reload('25c8a409', component.options)
    }
    module.hot.accept("./controlSalesGoodsItem.vue?vue&type=template&id=25c8a409&scoped=true", function () {
      api.rerender('25c8a409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/goodsManage/components/controlSalesGoodsItem.vue"
export default component.exports